import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/internal/operators/switchMap';

import { MenuCategory } from '../../shared/menu/menu-category.model';
import { MenuSubMenu } from '../../shared/menu/menu-sub-menu.model';
import { FullMenuService } from '../full-menu.service';


@Component({
  selector: 'app-full-menu-option',
  templateUrl: './full-menu-option.component.html',
  styleUrls: ['./full-menu-option.component.css']
})
export class FullMenuOptionComponent implements OnInit {

  @Input() itemsCount: number;
  @Input() menuOption: MenuCategory;
  @Input() shouldLoadOption: boolean;
  @Input() selectedCategoryName: string;

  menuName: string;
  translationKey: string;
  categorySubMenus: Array<MenuSubMenu>;
  subCategory: Array<string>;
  selectedSortType: string;

  menuTabIndex:number;

  constructor(private activeRoute: ActivatedRoute, private fullMenuService: FullMenuService) { }

  ngOnInit() {
    this.shouldLoadOptionAndMakeScrollIntoCategory();
    this.fullMenuService.getSortType().subscribe((sortType: string) => {
      if (this.selectedSortType !== sortType) {
        this.selectedSortType = sortType;
      }
    });
    this.fullMenuService.getMenuTabindex().subscribe((menuTabIndex: number) => {      
      this.menuTabIndex = menuTabIndex;      
    });
    
  }

  ngAfterViewInit() {
    this.shouldLoadOptionAndMakeScrollIntoCategory();
  }

  ngOnChanges() {
    
    this.menuName = this.menuOption.name;
    this.translationKey = this.menuOption.translationKey;
    this.itemsCount = 0;
    if (this.menuOption.subMenus) {
      this.itemsCount = this.menuOption.subMenus.length;
      this.subCategory = Array.from(new Set(this.menuOption.subMenus.map(x => x.subCategory)));
      this.subCategory  =  [...this.subCategory].sort(
        (sc1,  sc2)  => { 
            if(sc1 == null) {return -1;}
            if(sc1 != null) {return 1;}
            return 0;
        });
    }
  }

  getMenuItemList(subCategory: string) {

    return this.fullMenuService.sortMenu(this.menuOption.subMenus.filter((menu) => subCategory === menu.subCategory));
  }

  private shouldLoadOptionAndMakeScrollIntoCategory() {
    if (this.shouldLoadOption) {
      setTimeout(() => { this.scrollIntoCategory() });
    }
  }

  onExpandPanel(elementName: string): void {

    document.getElementById('icon_' + elementName).className = "icon-arrow-down";
    document.getElementById('title_' + elementName).className += " menu-option-expansion-panel-title-orange";
  }

  onCollapsePanel(elementName: string): void {

    let title: HTMLElement = document.getElementById('title_' + elementName);
    document.getElementById('icon_' + elementName).className = "icon-arrow-up";
    title.className = title.className.replace("menu-option-expansion-panel-title-orange", "");
    this.shouldLoadOptionAndMakeScrollIntoCategory();
  }

  private scrollIntoCategory() {
    let element: HTMLElement;
    let header = 0;
    if(document.getElementById("header") != null && document.getElementById("header").offsetHeight != null)
    header =  document.getElementById("header").offsetHeight;
    if (this.activeRoute && this.activeRoute.paramMap) {
      this.activeRoute.paramMap.pipe(
        switchMap((params: ParamMap) => {
          return of(params.get('category'));
        })).subscribe((category: string) => {
          if (category)
            element = document.getElementById('title_' + category);
        });
    }
    if (element) {
      let scrollElm: Element = document.scrollingElement;
      scrollElm.scrollTop = element.offsetTop - header;
    }
    
  }

  hasMoreThanOneItem(): boolean {

    return this.itemsCount > 1;
  }

  get isExpanded(): boolean {

    return (this.selectedCategoryName == null || !this.selectedCategoryName) ? true : this.menuName == this.selectedCategoryName;
  }
}
